module.exports = __webpack_public_path__ + "static/media/banner.56f9c4b1.png";